<template>
  <!-- 保函主要界面 -->
  <div style="overflow-y: auto">
    <top></top>
    <div class="container">
      <div class="left">
        <div class="imgdiv">
          <img src="@/assets/touxiang.png" />
        </div>
        <div class="corporateName" v-if="sunshinePurchase">
          {{ corporateName }}
        </div>
        <h3>{{ username1 }}</h3>
        <hr
          style="
            background: #e1e8ec;
            width: 160px;
            margin-left: auto;
            margin-right: auto;
            margin: 0 auto 30px auto;
          "
        />
        <!-- <ul>
					<li v-for="(cate, index) in categories" :key="index" :data-cateid="cate.cateid" :data-index="index" :class="[cateCurrentIndex == index ? 'grace-tab-current' : '']"
					 @click="tabChange"><img style="margin-right:5px;margin-top: -5px;" src="@/assets/1.png" />{{cate.name}}</li>
				</ul> -->
        <connomtab :class="{ baohansystem: isnowpage }"></connomtab>
      </div>
      <div class="right" v-show="rigth_show">
        <applybaohan></applybaohan>
        <!-- <applyrecord  v-else-if="num === 1"></applyrecord> -->
        <!-- <Details  v-else-if="num === 'detail'"></Details> -->
        <!-- <Details v-else></Details> -->
      </div>
      <div class="msg_box" v-show="u1_show">
        <div class="u1">
          <!-- Unnamed (矩形) -->
          <div>
            <div class="bh_notice">电子保函申请须知</div>
            <div class="bh_notice_msg">
              <p>
                为了确保您在电子保函申请过程中流程顺利，在使用公航旅电子交易中心平台（以下简称“本网站”）申请保函之前，请务必仔细阅读本声明。若您对本声明的任何条款有异议，请停止使用本网站所提供的全部服务。
              </p>
              <p>
                <span
                  >1、本网站采用数字证书（Ukey）对企业信息进行校验和签章，申请之前请确认企业拥有甘肃省公共资源主体共享平台认证通过的数字证书（Ukey）。</span
                >
              </p>
              <p>
                <span
                  >2、当您的企业相关信息发生变更请及时到主体库变更您的企业相关信息，由于您未及时更改信息而导致的数据错误，本网站概不负责。请确保你的企业相关信息在主体库是最新信息。</span
                >
              </p>
              <p>
                <span
                  >3、本网站将在您授权的前提下获取您在交易平台的企业基础信息、投标项目部分信息、历史投标和中标次数记录，用于第三方担保机构审核投标人的申请资格，您已确认将信息授权与本网站，本网站承诺不会将您的信息使用在其他地方。</span
                >
              </p>
              <p>
                <span
                  >4、电子保函申请审核结果以担保机构审核结果通知为准，审核周期为2个工作日，由于审核不通过而造成的投标失效本网站不负任何责任，请及时确认好您的项目投标截止日期，以免错过投标机会。</span
                >
              </p>
              <p>
                <span
                  >5、本网站仅提供技术服务，保函服务费由担保机构收取，本网站不承担任何投标人与担保机构之间的费用纠纷。</span
                >
              </p>
              <p>
                <span
                  >6、互联网传输可能会受到干扰，中断、延迟或数据错误，本网站对于非本网站能控制的通讯设施故障可能引致的数据及交易之准确性或及时性不负任何责任。</span
                >
              </p>
              <p style="font-weight: bold">
                <span>
                  您承诺接受并遵守本协议的约定，
                  届时您不应以未阅读本协议的内容或者未获得公航旅电子交易中心平台对您问询的解答等理由，主张本协议无效，或要求撤销本协议。
                </span>
              </p>
            </div>

            <!-- Unnamed (矩形) -->
            <div id="u3" class="cursor" lay-submit lay-filter="into">
              <div id="u3_text" class="text">
                <!-- <p><span>进入电子保函系统</span></p> -->
                <button
                  style="width: 186px"
                  @click="u3_btn"
                  type="button"
                  class="u3_text_btn layui-btn"
                >
                  立即申请保函
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="common_problem">
          <p>常见问题</p>
          <p></p>
          <p>Q：出具保函需要多长时间？</p>
          <p>A：审核通过后，一个工作日内左右即可出具电子保函。</p>
          <p>Q：保函怎么收费？</p>
          <p>
            A：保函费用单笔收费，甘南地区及金塔县保函费率为保证金费用2%，最低收费标准800元，甘肃其他地区保函费率为保证金费用的2%，最低收费标准500元。
          </p>
          <p>Q：交易中心怎么收取电子保函？</p>
          <p>
            A：根据招标文件具体要求将电子保函复印件播入投标文件中或将电子保函原件复制到优盘中携带至开标现场。
          </p>
          <p>Q：没有数字证书能申请电子保函吗？</p>
          <p>
            A：申请电子保函的材料必须使用数字证书进行电子签章，否则您的申请无效，
            <span @click="ca_credential" class="ca_click">点击这里</span>
            立即申请数字证书。
          </p>
          <p>联系客服</p>
          <p></p>
          <p>办理过程中，有任何问题，均可与客服联系</p>
          <p>
            <span>客服电话：</span
            ><span
              ><div>(028)85318677</div>
              <div>18181947441</div></span
            >
          </p>
          <p>人工服务时间09:00-17:00(周一至周五)</p>
        </div>
      </div>

      <div class="clear"></div>
    </div>
    <!-- 正常运营通知 -->
    <div class="feedbackdiv" v-show="operationMsg">
      <div class="feedback_content">
        <div class="feedback_title">
          公航旅电子交易中心平台正常运营通知
        </div>
        <p style="text-indent: 2em">
          为加强新型冠状病毒感染的肺炎疫情防控工作，有效减少人员聚集，阻断疫情传播，公航旅电子交易中心平台系统已于2020年2月3日恢复正常运营，投标人可在平台全程在线申请电子保函，避免人员外出产生不必要的接触。
        </p>
        <p style="margin-top: 30px">运营期间担保机构具体业务开展情况如下：</p>
        <p>甘肃担保：保函申请服务已恢复，审核、出函时间待定</p>
        <p>瀚华担保：保函申请、审核、出函服务已恢复</p>
        <p style="margin-top: 75px; text-align: right">
          公航旅电子交易中心平台
        </p>
        <p style="text-align: right">2020年02月03日</p>
        <button type="button" @click="closeMsg">关闭通知页面</button>
      </div>
    </div>
  </div>
</template>

<script>
var loading;
import top from "@/components/Head/Head.vue";
import applybaohan from "@/components/apply-baohan/apply-baohan";
import applyrecord from "@/components/apply-record/apply-record";
import connomtab from "@/components/connom_tab/connom_tab";
import { mapGetters } from "vuex";
export default {
  components: {
    top,
    applybaohan,
    applyrecord,
    connomtab,
  },
  name: "baohansystem",
  data() {
    return {
      username1: "",
      operationMsg: false,
      bh_img: false,
      rigth_show: false,
      u1_show: true,
      isnowpage: true,
      categories: [
        {
          cateid: 0,
          name: "申请电子保函",
        },
        {
          cateid: 1,
          name: "保函申请记录",
        },
        /* {
						cateid: 2,
						name: "企业信息管理"
					} */
      ],
      num: 0,
      cateCurrentIndex: 0,
      heh: Object,
      second: Number,
      yes: false,
    };
  },
  computed: {
    ...mapGetters({
      corporateName: "getCorporateName",
      sunshinePurchase: "getSunshinePurchasee",
    }),
  },
  beforeCreate() {},
  created() {
    this.bh_img = true;
    if (sessionStorage.getItem("u1_show") == "1") {
      this.u1_show = false;
      this.rigth_show = true;
    }

    if (["1", "2"].includes(sessionStorage.getItem("accredit"))) {
      this.u1_show = false;
      this.rigth_show = true;
    }
    if (sessionStorage.getItem("closeMsgIndex") == "1") {
      this.operationMsg = false;
    }
    if (sessionStorage.getItem("closeMsg") == "1") {
      this.operationMsg = false;
    }
    var that = this;
    this.$http.get("/erong/getNickName").then((res) => {
      if (res.data.status == 1) {
        this.username1 = res.data.msg;
      } else {
        this.username1 = "公航旅电子交易中心平台用户";
      }
    });
  },
  mounted() {},
  methods: {
    // 关闭通知页面
    closeMsg() {
      this.operationMsg = false;
      sessionStorage.setItem("closeMsgIndex", "1");
    },
    ca_credential() {
      window.open("http://47.99.121.153:8081");
    },
    u3_btn() {
      this.bh_img = true;
      this.u1_show = false;
      this.rigth_show = true;
      sessionStorage.setItem("u1_show", "1");
    },
    // 			myevent2(e){
    // 				var that = this;
    // 		that.heh = e;
    // 		that.num = that.heh.name;
    // 		return false;
    //
    // 		},
    tabChange(e) {
      // 选中的索引
      var index = e.currentTarget.dataset.index;
      index = Number(index);
      this.num = index;

      // 具体的分类id
      var cateid = e.currentTarget.dataset.cateid;
      this.cateCurrentIndex = index;
      // 动态替换内容
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.feedbackdiv {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  outline: 0;
  -webkit-overflow-scrolling: touch;
  background-color: #a6abaf;
  filter: alpha(opacity=60);
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9998;
  .feedback_content {
    border: 1px solid #ccc;
    position: absolute;
    width: 438px;
    height: 534px;
    border: 0px;
    top: 50%;
    left: 50%;
    margin-top: -267px;
    margin-left: -220px;
    background-color: #fff;
    z-index: 9999;
    .feedback_title {
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      line-height: 80px;
      margin-top: 30px;
      color: #333333;
    }
    p {
      padding: 0px 50px;
      font-size: 13px;
      line-height: 23px;
      font-weight: 550;
      color: #333333;
      text-indent: 2em;
    }
    button {
      border: none;
      width: 250px;
      height: 40px;
      color: #fff;
      background: #1aaecf;
      margin-top: 42px;
      margin-left: 93px;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
.msg_box {
  display: flex;
}
.u1 {
  // height: 656px;
  width: 633px;
  padding: 0px 20px;
  display: flex;
  background: #ffffff;
  // border-left:  1px solid #e1e8ec;
  // border-right:  1px solid #e1e8ec;
  border: 1px solid #e1e8ec;
  margin-left: 30px;
}
.u1_right {
  width: 400px;
  background-color: red;
  margin-left: 100px;
}
.bh_notice {
  width: 100% !important;
  padding: 29px 20px 0 20px;
  color: #666;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  width: 732px;
}
.bh_notice_msg {
  width: 590px;
  background-color: #f9f9f9;
  padding: 10px 20px 20px 20px;
  font-size: 13px;
  color: #333;
  // margin: 0 auto;
  text-indent: 2em;
  line-height: 28px;
  //  margin: 20px auto 0 auto;
  margin-top: 20px;
  p {
    &:nth-child(1) {
      margin-bottom: 20px;
    }
  }
}
.u3_text_btn {
  margin: 40px 0px 0px 233px;
}
.common_problem {
  width: 214px;
  background: #ffffff;
  border: 1px solid #e1e8ec;
  margin-left: 30px;
  padding: 0px 20px;

  p {
    line-height: 24px;
    font-size: 13px;
    .ca_click {
      cursor: pointer;
      color: rgb(16, 108, 230);
    }
    &:nth-child(1) {
      font-size: 16px;
      color: #838383;
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 15px;
    }
    &:nth-child(11) {
      font-size: 16px;
      color: #838383;
      height: 50px;
      line-height: 50px;
      margin-top: 15px;
    }
    &:nth-child(12) {
      height: 2px;
      background: #e5e5e5;
      margin-bottom: 10px;
    }
    &:nth-child(14) {
      display: flex;
      font-size: 16px;
      color: #19aecf;
      line-height: 30px;
    }
    &:nth-child(13) {
      line-height: 30px;
    }
    &:nth-child(15) {
      line-height: 30px;
    }
    &:nth-child(2) {
      height: 2px;
      background: #e5e5e5;
      margin-bottom: 10px;
    }
    &:nth-child(3),
    &:nth-child(5),
    &:nth-child(7),
    &:nth-child(9) {
      color: #19aecf;
    }
    &:nth-child(4),
    &:nth-child(6),
    &:nth-child(8),
    &:nth-child(10),
    &:nth-child(13),
    &:nth-child(15) {
      color: #7b7b7b;
    }
  }
}
.layui-btn {
  line-height: 40px;
}
.block-center {
  margin: 0 auto;
}
.container {
  display: flex;
  width: 1200px;
  .block-center;
  & > div.left {
    min-width: 202px;
    background: #ffffff;
    border: 1px solid #e1e8ec;
    .imgdiv {
      width: 100px;
      height: 100px;
      background: #19aecf;
      margin: 50px auto 14px auto;
    }
    h3 {
      font-size: 14px;
      color: #3c4f57;
      letter-spacing: 0;
      text-align: center;
      margin-bottom: 28px;
    }
    ul {
      width: 160px;
      margin: 0 auto;
      li {
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        letter-spacing: 0;
        margin-bottom: 10px;
        border: 1px solid #ffffff;
      }
      li.grace-tab-current {
        color: #19aecf;
        background: rgba(25, 174, 207, 0.03);
        border: 1px solid #19aecf;
      }
    }
  }
  & > div.right {
    width: 978px;
    background: #ffffff;
    // border-left:  1px solid #e1e8ec;
    // border-right:  1px solid #e1e8ec;
    border: 1px solid #e1e8ec;
    // border-top: 1px solid #e1e8ec;
    margin-left: 30px;
  }
}
.corporateName {
  padding: 0 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 14px;
  color: #3c4f57;
  letter-spacing: 0;
  margin-bottom: 10px;
}
</style>
